import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { appliedThemeAtom } from '@frontend/atoms/appearanceAtom';

export function useTheme() {
  // Preview-aware: a live preview (hover/focus) takes precedence over the committed theme.
  const applied = useAtomValue(appliedThemeAtom);

  useEffect(() => {
    const root = document.documentElement;

    // 'light dark' is CSS's own "let the OS decide" value — Axiom's tokens
    // are built on light-dark(), which resolves off the computed color-scheme
    // (see features/vau/directory/components/shared/shared.css.ts for the
    // same mechanism used the other way, forcing 'light'), so this alone is
    // enough to make the whole app track prefers-color-scheme with no polling.
    root.style.colorScheme = applied === 'system' ? 'light dark' : applied;
  }, [applied]);
}
